/**
 * The full-screen wait while the app works out who you are (and, on /admin,
 * whether you may be there): the board's warm dotted surface with the Floto
 * loader animating in the middle — the same ground the sign-in screens stand
 * on, so the hand-off from this to them reads as one screen settling.
 *
 * It fades in after a beat rather than at once: the session check usually
 * answers in well under that, and a loader that flashes for a few frames
 * reads as a glitch.
 */
export function AppLoading({ label = 'Loading…' }: { label?: string }) {
  return (
    <main
      aria-busy="true"
      className="relative isolate grid min-h-svh place-items-center overflow-hidden bg-warm"
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10 opacity-[0.07] [background-image:radial-gradient(#1a1a1a_1px,transparent_1px)] [background-size:24px_24px]"
      />
      <div
        className="flex flex-col items-center gap-4 fill-mode-both duration-500 animate-in fade-in [animation-delay:250ms] motion-reduce:animate-none"
        role="status"
      >
        <img
          alt=""
          aria-hidden="true"
          className="h-auto w-32"
          src="/loaders/floto-loader.svg"
        />
        <p className="text-caption tracking-wide text-text-muted">{label}</p>
      </div>
    </main>
  );
}
